import React, { useContext, useEffect } from 'react';
import styles from './BulkActions.module.scss';
import { Action, CheckmarkRoundSmall, CloseRoundSmall } from 'esa-ui-library';
import { useStore } from '../../../../../common';
import { PERMISSIONS } from '../../../..';
import { AuthContext } from '../../../../../logic';

const BulkActions = (): JSX.Element => {
	const [{ currentPage }, dispatch] = useStore();
	const { user, token } = useContext(AuthContext);

	useEffect(() => {
		return () => dispatch('BULK_ACTIONS_INVALIDATE');
	}, []);

	const onAccountsActivate = async () => {
		await dispatch('ACTIVATE_GAMES', token);
		dispatch('PAGE_UPDATE', { token, page: currentPage });
	};

	const onAccountsDeactivate = async () => {
		await dispatch('DEACTIVATE_GAMES', token);
		dispatch('PAGE_UPDATE', { token, page: currentPage });
	};

	return (
		<section className={styles.BulkActions}>
			{(user?.permissions?.isSuperAdmin || user?.permissions[PERMISSIONS.canDisableUser]) && (
				<>
					<Action
						className={styles.Action}
						label='Activate'
						onClick={onAccountsActivate}
						icon={<CheckmarkRoundSmall />}
					/>
					<Action
						className={styles.Action}
						label='Deactivate'
						onClick={onAccountsDeactivate}
						icon={<CloseRoundSmall />}
					/>
				</>
			)}
		</section>
	);
};

export { BulkActions };
